var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div dias-cloak=\"vm.loading\" ng-if=\"vm.relevantKategoriewerte.length\"><div vueinit props=\"{ kategoriewerte: vm.kategoriewerte, categoriesAll: vm.categoriesAll, showList: true  }\"><vue-foerderfinder-icons v-bind:kategoriewerte=\"propsAngular.kategoriewerte\" v-bind:categories-all=\"propsAngular.categoriesAll\" v-bind:show-list=\"propsAngular.showList\"></vue-foerderfinder-icons></div></div><div ng-if=\"!vm.relevantKategoriewerte.length\">keine Angabe</div>");;return buf.join("");
}